import React, { Component } from "react";
import PropTypes from "prop-types";
import Flickity from "flickity";
import flickityOptions from "../../../helpers/flickityOptions";
import Navigation from "./Navigation";
import isEqual from "lodash/isEqual";

export default class Slideshow extends Component {
  static displayName = "Slideshow";
  static propTypes = {
    slides: PropTypes.arrayOf(PropTypes.object).isRequired,
    renderSlide: PropTypes.func.isRequired,
    active: PropTypes.number.isRequired,
    onUpdate: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.slideshow = new Flickity(this.sliderEl, {
      ...flickityOptions,
      initialIndex: this.active,
    });
    this.slideshow.on("change", this.props.onUpdate);
  }

  getSnapshotBeforeUpdate(prevProps) {
    if (!isEqual(this.slides, prevProps.slides)) {
      this.slideshow.destroy();
      return "destroyed";
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot !== null) {
      this.slideshow = new Flickity(this.sliderEl, {
        ...flickityOptions,
        initialIndex: this.active,
      });
      this.slideshow.on("change", this.props.onUpdate);
    }
    if (this.active !== prevProps.active) {
      this.slideshow.select(this.active);
    }
  }

  componentWillUnmount() {
    this.slideshow.destroy();
  }

  get active() {
    return this.props.active;
  }

  get slides() {
    return this.props.slides;
  }

  handlePreviousClick = () => {
    const newSlide =
      this.active === 0 ? this.slides.length - 1 : this.active - 1;
    this.updateActive(newSlide);
  };

  handleNextClick = () => {
    const newSlide =
      this.active === this.slides.length - 1 ? 0 : this.active + 1;
    this.updateActive(newSlide);
  };

  updateActive(newActive) {
    if (this.active !== newActive) {
      this.props.onUpdate(newActive);
    }
  }

  render() {
    return (
      <div className="m-slideshow">
        <div
          ref={(s) => {
            this.sliderEl = s;
          }}
          className="m-slideshow__inner"
        >
          {this.slides.map((slide, index) => (
            <div className="m-slide" key={slide.id}>
              {this.props.renderSlide(slide, index)}
            </div>
          ))}
        </div>
        <Navigation
          count={this.slides.length}
          onUpdate={this.props.onUpdate}
          active={this.active}
        />
      </div>
    );
  }
}
